export default "__VITE_ASSET__758kyoNC__"